<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-data-table
        :headers="headers"
        :items="connections"
        :items-per-page="-1"
        :height="conentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :custom-filter="customFilter"
        @contextmenu:row="rowMenuClick">

        <template v-slot:[`item.numericPlate`]="{ item }">
          {{ item.numericPlate || "-" }}
        </template>
        <template v-slot:[`item.device`]="{ item }">
          {{ item.deviceType + "@" + item.deviceCode }}
        </template>
        <template v-slot:[`item.connectedFrom`]="{ item }">
          {{ formatDateTime(item.connectedFrom) }}
        </template>
      </v-data-table>
      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <v-list-item v-for="(item, index) in contextItems"
                       :key="index"
                       link
                       @click="rowMenuItemClick(item)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import ResizablePage from "@/components/ResizablePage";
import { DateTime } from "luxon";

export default {
  name: "DeviceConnectionsView",
  components: { ResizablePage },

  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextDevice: null,
      contextItems: [
        { name: "log", title: "Zobrazit na log" }
      ],

      headers: [
        {
          text: this.$t("table.deviceConnections.header.numeric_plate"),
          align: "start",
          sortable: true,
          width: "15%",
          value: "numericPlate"
        },
        {
          text: this.$t("table.deviceConnections.header.device"),
          align: "start",
          sortable: true,
          width: "20%",
          value: "device"
        },
        {
          text: this.$t("table.deviceConnections.header.ip"),
          align: "start",
          sortable: true,
          width: "15%",
          value: "hostAddress"
        },
        {
          text: this.$t("table.deviceConnections.header.connected_from"),
          align: "start",
          sortable: true,
          width: "26%",
          value: "connectedFrom"
        },
        {
          text: this.$t("table.deviceConnections.header.packets"),
          align: "start",
          sortable: true,
          width: "12%",
          value: "packets"
        },
        {
          text: this.$t("table.deviceConnections.header.measures"),
          align: "start",
          sortable: true,
          width: "12%",
          value: "measures"
        }
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },

    connections: function() {
      return this.$store.state.data.records.map(x => {
        return {
          numericPlate: x.numericPlate,
          deviceType: x.deviceType,
          deviceCode: x.deviceCode,
          hostAddress: x.hostAddress,
          connectedFrom: x.connectedFrom,
          packets: x.packets,
          measures: x.measures
        };
      });
    }
  },

  methods: {
    customFilter(value, search, item) {
      let ls = search.toLowerCase();
      return (item.numericPlate !== null && item.numericPlate.toLowerCase().includes(ls))
        || (item.deviceCode !== null && item.deviceCode.toLowerCase().includes(ls))
        || (item.hostAddress !== null && item.hostAddress.toLowerCase().includes(ls));
    },

    formatDateTime(dt) {
      return DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_SHORT);
    },

    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextDevice = item.item;

      event.preventDefault();
    },

    rowMenuItemClick(item) {
      switch (item.name) {
        case "log":
          if (this.contextDevice.numericPlate !== null)
            this.showLog(this.contextDevice.numericPlate);
          break;
      }
    },

    showLog(numericPlate) {
      this.$store.dispatch("data/findVehicles", numericPlate).then(result => {
        if (result.data !== null && result.data.length > 0)
        this.$store.dispatch("dialogs/showDialog", {
          dialog: "vehicleLog", options:
            { vehicle: result.data[0] }
        });
      });
    }
  },

  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "device-connection" });
  },

  destroyed() {
    this.mounted = false;
  }
};
</script>

<style lang="sass" scoped>
.normal-flag-move
  margin: -10px -5px !important
</style>